<template>
<f7-page ref="twitterPage" :page-content="false" name="twitter-view">
  <!-- Header View Component -->
  <app-header :header="Twitter.PageTitle" ref="twitterAppHeader"></app-header> 
  <!-- Menu View Component  -->
  <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
  <div class="backgroundimg"></div>
  <div class="outer-container">
    <div v-if="showDevSimInitMsg" class="no-page-found">
      <div>{{resource.noPageFound}}</div>
    </div>
  </div>
  <f7-page-content v-show="dataLoaded && imgLoaded" ref="twitterContainer" class="twitterpage">
    <f7-card-header class="twitter-card-header" v-if="TwitterUserDetail != null && Twitter.TwitterId != ''">
      <f7-row>
        <div class="col-100 twitter-cover"> 
          <div :class="{no_banner_height : TwitterUserDetail.ProfileBannerUrl === null , banner_height : TwitterUserDetail.ProfileBannerUrl !== null }"></div>
          <div class="inner-cover" v-if="TwitterUserDetail.ProfileBannerUrl !== undefined">
            <img :src="TwitterUserDetail.ProfileBannerUrl" style="transform: none;" @click="onClickImage(1, TwitterUserDetail.StatusesCount)"/>
            <app-image-full-screen :ref="TwitterUserDetail.StatusesCount" :photos="getPhotoArray(TwitterUserDetail.ProfileBannerUrl,null,null)"></app-image-full-screen>
          </div>
        </div>
        <div class="u_width-100 twitter-user-info">
            <div class="profile-pic">
              <img v-if="TwitterUserDetail.ProfileImageUrlHttps" :src="getProfileFullImage(TwitterUserDetail.ProfileImageUrlHttps)" v-on:load="onLoaded" class="twitter-profilepic" @click="onClickImage(1, TwitterUserDetail.UserID)"/>
              <app-image-full-screen :ref="TwitterUserDetail.UserID" :photos="getPhotoArray(TwitterUserDetail.ProfileImageUrlHttps,null,null)"></app-image-full-screen>
            </div>
            <div class="col-100">
              <b class="twitter-user-name">{{TwitterUserDetail.Name}}</b>
              <div>
                <span class="twitter_screenName">@{{TwitterUserDetail.ScreenNameResponse}}</span>
              </div>
            </div>
          <div>
          <div class="twitter-description" v-html="TwitterUserDetail.Description"></div>
          <div class="twitter-user-other-info">
            <span v-if="TwitterUserDetail.Location"><i class="material-icons" style="font-size: 17px;">location_on</i>{{TwitterUserDetail.Location}}</span>
          </div>
          <div class="twitter-user-other-info"><span><f7-icon f7="calendar" class="twitter-icon calender-font-icon" >
          </f7-icon>{{ language === 'en' ? resource.strDateJoin : '' }} {{twitterDateFormat(TwitterUserDetail.CreatedAt)}} {{ language === 'de' ? resource.strDateJoin : '' }}</span></div>
            <div>
              <span><b class="twitter-post-username">{{nFormatter(TwitterUserDetail.FriendsCount)}}</b> {{resource.twitterfollowing}} </span>
              <span class="twitter-span-margin"><b class="twitter-post-username">{{nFormatter(TwitterUserDetail.FollowersCount)}}</b> {{resource.twitterfollowers}}</span>
          </div>
        </div>
            </div>
        </f7-row>
    </f7-card-header>
    <f7-toolbar tabbar class="twitter-tab-bar" v-if="mediaList.length > 0">
      <f7-link class="set twitter-case" tab-link="#tab-1" tab-link-active>{{resource.Tweets}}</f7-link>
        </f7-toolbar>
          <f7-tabs class="twitter-tabs">
            <f7-tab id="tab-1" class="page-content" tab-active>
              <f7-card v-for="(media, index) in mediaList" :key="index" v-if="mediaList.length > 0">
                <f7-card-content class="twitter-tweet-card">
                  <div v-if="!media.Retweeted" class="tweet-details">
                    <div class="tweet-profile-pic"> 
                      <img v-if="TwitterUserDetail.ProfileImageUrlHttps" :src="getProfileFullImage(TwitterUserDetail.ProfileImageUrlHttps)" class="show-profile-pic-small"/>
                    </div>
                    <div class="tweet-profile-details flex-grow-1">
                      <b class="twitter-post-username">{{TwitterUserDetail.Name}}</b>
                      <span class="twitter-post-date">{{formattedDate(media.CreatedAt)}}</span>
                      <div class="twitter-post-description " v-html="media.FullText"></div>
                      <div v-if="media.ExtendedEntities.MediaEntities.length!==0 && media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants && media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants.length !=0 && media.ExtendedEntities.MediaEntities[0].Type ==='video'" class="twitter-video-div" :style="getVideoThumbnail(media.ExtendedEntities.MediaEntities[0].MediaUrlHttps)">
                        <div :style="getVideoDivStyle(media.ExtendedEntities.MediaEntities[0].VideoInfo.AspectRatio)"></div>
                        <div class="twitter-video-outer-div">
                          <video ref="twitterVid" :id="videoId" @click="SetControl()" preload="auto" playsinline="" width="100%" height="100%" @play="checkPlayer(media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" controls controlsList="nodownload" @loadstart="handleAutoplayPause()">
                            <source :src="getVideoUrl(media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" type="video/mp4">
                          </video>
                        </div>
                      </div>
                      <div v-if="media.ExtendedEntities.MediaEntities.length!==0 &&  media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants && media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants.length !=0 && media.ExtendedEntities.MediaEntities[0].Type ==='animated_gif'" class="twitter-video-div" :style="getVideoThumbnail(media.ExtendedEntities.MediaEntities[0].MediaUrlHttps)">
                        <div :style="getVideoDivStyle(media.ExtendedEntities.MediaEntities[0].VideoInfo.AspectRatio)"></div>
                        <div class="twitter-video-outer-div">
                          <video ref="twitterVid" :id="videoId" @click="SetControl()" preload="auto" playsinline="" width="100%" height="100%" @play="checkPlayer(media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" controls loop controlsList="nodownload" @loadstart="handleAutoplayPause()">
                            <source :src="getVideoUrl(media.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" type="video/mp4">
                          </video>
                          </div>
                          <div class="gif-label">{{resource.gif}}</div>
                        </div>
                        <div v-else>
                          <div class="show-media-image" v-if="media.ExtendedEntities.MediaEntities.length===1 && media.ExtendedEntities.MediaEntities[0].Type === 'photo'">
                            <div :key="index" v-for="(image, index) in media.ExtendedEntities.MediaEntities" v-if="media.Entities" @click="onClickImage(index,  media.StatusID)"  :style="'background-image: url('+ image.MediaUrlHttps +')'"> </div>
                            <app-image-full-screen :ref="media.StatusID" :photos="getPhotoArray(media.ExtendedEntities.MediaEntities,media.RetweetCount,media.FavoriteCount)"></app-image-full-screen>
                          </div> 
                          <div class="show-media-image gallery2" v-if="media.ExtendedEntities.MediaEntities.length===2">
                            <div :key="index" v-for="(image, index) in media.ExtendedEntities.MediaEntities" v-if="media.Entities" @click="onClickImage(index, media.StatusID)" :style="'background-image: url('+ image.MediaUrlHttps +')'"> </div>
                            <app-image-full-screen :ref="media.StatusID" :photos="getPhotoArray(media.ExtendedEntities.MediaEntities,media.RetweetCount,media.FavoriteCount)"></app-image-full-screen>
                          </div>
                          <div class="show-media-image gallery3" v-if="media.ExtendedEntities.MediaEntities.length===3">
                            <div  v-for="(image, index) in media.ExtendedEntities.MediaEntities" v-if="media.Entities" :key="index" @click="onClickImage(index, media.StatusID)" :style="'background-image: url('+ image.MediaUrlHttps +')'">
                            </div>
                            <app-image-full-screen :ref="media.StatusID" :photos="getPhotoArray(media.ExtendedEntities.MediaEntities,media.RetweetCount,media.FavoriteCount)"></app-image-full-screen>
                          </div>
                          <div class="show-media-image gallery4" v-if="media.ExtendedEntities.MediaEntities.length===4">
                            <div  v-for="(image, index) in media.ExtendedEntities.MediaEntities" v-if="media.Entities" :key="index"  @click="onClickImage(index, media.StatusID)"  :style="'background-image: url('+ image.MediaUrlHttps +')'">   
                            <app-image-full-screen :ref="media.StatusID" :photos="getPhotoArray(media.ExtendedEntities.MediaEntities,media.RetweetCount,media.FavoriteCount)"></app-image-full-screen>           
                          </div>
                        </div>
                      </div>
                </div>
                </div> 
                <div v-else class="tweet-details">
                 <div class="tweet-profile-pic">
                    <i class="retweet retweet-rotate"></i>
                    <img v-if="media.RetweetedStatus.User.ProfileImageUrlHttps" :src="media.RetweetedStatus.User.ProfileImageUrlHttps" class="show-profile-pic-small"/>
                  </div>
                  <div class="tweet-profile-details flex-grow-1">
                    <div class="retweeted-text-name" v-if="media.User">{{media.User.Name}} {{resource.Retweeted}}</div>
                    <b class="twitter-post-username" v-if="media.RetweetedStatus.User">{{media.RetweetedStatus.User.Name}} </b>
                    <span class="twitter-post-date"> {{formattedDate(media.RetweetedStatus.CreatedAt)}}</span>
                    <div class="twitter-post-description " v-html="media.FullText"></div>
                    <div v-if="media.RetweetedStatus.ExtendedEntities.MediaEntities.length!==0 &&  media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants && media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants.length !=0 && media.RetweetedStatus.ExtendedEntities.MediaEntities[0].Type === 'video'" class="twitter-video-div" :style="getVideoThumbnail(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].MediaUrlHttps)">
                    <div :style="getVideoDivStyle(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.AspectRatio)"></div>
                    <div class="twitter-video-outer-div">
                    <video ref="twitterVid" :id="videoId" @click="SetControl()" preload="auto" playsinline="" width="100%" height="100%" @play="checkPlayer(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" controls controlsList="nodownload" @loadstart="handleAutoplayPause()">
                            <source :src="getVideoUrl(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" type="video/mp4">
                    </video>
                    </div>
                   </div>
                   <div v-if="media.RetweetedStatus.ExtendedEntities.MediaEntities.length!==0 &&  media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants && media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants.length !=0 && media.RetweetedStatus.ExtendedEntities.MediaEntities[0].Type === 'animated_gif'" class="twitter-video-div" :style="getVideoThumbnail(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].MediaUrlHttps)">
                   <div :style="getVideoDivStyle(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.AspectRatio)"></div>
                   <div class="twitter-video-outer-div">
                    <video ref="twitterVid" :id="videoId" @click="SetControl()" preload="auto" playsinline="" width="100%" height="100%"  @play="checkPlayer(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" controls loop controlsList="nodownload" @loadstart="handleAutoplayPause()">
                            <source :src="getVideoUrl(media.RetweetedStatus.ExtendedEntities.MediaEntities[0].VideoInfo.Variants)" type="video/mp4">       
                    </video>
                    </div>
                    <div class="gif-label">{{resource.gif}}</div>
                   </div>
                    <div v-else>
                    <div class="show-media-image" v-if="media.RetweetedStatus.ExtendedEntities.MediaEntities.length===1 && media.RetweetedStatus.ExtendedEntities.MediaEntities[0].Type==='photo'">
                      <div :key="index" v-for="(image, index) in media.RetweetedStatus.ExtendedEntities.MediaEntities" v-if="media.RetweetedStatus.Entities" @click="onClickImage(index, media.RetweetedStatus.StatusID)"  :style="'background-image: url('+ image.MediaUrlHttps +')'"> </div>
                      <app-image-full-screen :ref="media.RetweetedStatus.StatusID" :photos="getPhotoArray(media.RetweetedStatus.ExtendedEntities.MediaEntities,media.RetweetedStatus.RetweetCount,media.RetweetedStatus.FavoriteCount)"></app-image-full-screen>
                    </div>
                    <div class="show-media-image gallery2" v-if="media.RetweetedStatus.ExtendedEntities.MediaEntities.length===2">
                      <div :key="index" v-for="(image, index) in media.RetweetedStatus.ExtendedEntities.MediaEntities" v-if="media.RetweetedStatus.Entities" @click="onClickImage(index, media.RetweetedStatus.StatusID)" :style="'background-image: url('+ image.MediaUrlHttps +')'"> </div>
                      <app-image-full-screen :ref="media.RetweetedStatus.StatusID" :photos="getPhotoArray(media.RetweetedStatus.ExtendedEntities.MediaEntities,media.RetweetedStatus.RetweetCount,media.RetweetedStatus.FavoriteCount)"></app-image-full-screen>
                    </div>
                    <div class="show-media-image gallery3" v-if="media.RetweetedStatus.ExtendedEntities.MediaEntities.length===3">
                      <div :key="index" v-for="(image, index) in media.RetweetedStatus.ExtendedEntities.MediaEntities" v-if="media.RetweetedStatus.Entities" @click="onClickImage(index, media.RetweetedStatus.StatusID)" :style="'background-image: url('+ image.MediaUrlHttps +')'">
                       </div>
                       <app-image-full-screen :ref="media.RetweetedStatus.StatusID" :photos="getPhotoArray(media.RetweetedStatus.ExtendedEntities.MediaEntities,media.RetweetedStatus.RetweetCount,media.RetweetedStatus.FavoriteCount)"></app-image-full-screen>
                    </div>
                    <div class="show-media-image gallery4" v-if="media.RetweetedStatus.ExtendedEntities.MediaEntities.length===4">
                      <div :key="index" v-for="(image, index) in media.RetweetedStatus.ExtendedEntities.MediaEntities" v-if="media.RetweetedStatus.Entities" @click="onClickImage(index, media.RetweetedStatus.StatusID)" :style="'background-image: url('+ image.MediaUrlHttps +')'">
                    </div>
                    <app-image-full-screen :ref="media.RetweetedStatus.StatusID" :photos="getPhotoArray(media.RetweetedStatus.ExtendedEntities.MediaEntities,media.RetweetedStatus.RetweetCount,media.RetweetedStatus.FavoriteCount)"></app-image-full-screen>
                    </div>
                  </div>
                  </div>
              </div> 
          </f7-card-content>
          <div class="tweet-details card-content-padding">
                <div class="tweet-profile-pic"></div>
                
                  <f7-card-footer v-if="!media.Retweeted" class="no-border tweet-icon-padding justify-content-between flex-grow-1">
                 <div class="twitter-icon-div"><i class="retweet"></i><span style="line-height: initial;" v-if="media.RetweetCount!== 0">{{nFormatter(media.RetweetCount)}}</span></div>
                    <div class="twitter-icon-div"><i class="tweet-like"></i><span style="line-height: initial;" v-if="media.FavoriteCount!== 0">{{nFormatter(media.FavoriteCount)}}</span></div>
                  </f7-card-footer> 
                  <f7-card-footer v-else class="no-border tweet-icon-padding justify-content-between flex-grow-1">
                  <div class="twitter-icon-div"><i class="retweet"></i><span style="line-height: initial;" v-if="media.RetweetedStatus.RetweetCount!== 0">{{nFormatter(media.RetweetedStatus.RetweetCount)}}</span></div>
                    <div class="twitter-icon-div"><i class="tweet-like"></i><span style="line-height: initial;" v-if="media.RetweetedStatus.FavoriteCount!== 0">{{nFormatter(media.RetweetedStatus.FavoriteCount)}}</span></div>
                  </f7-card-footer>
             
           </div>
          </f7-card>
        </f7-tab>
        <div class="outer-container">
          <div v-if="TwitterUserDetail=== null && showRefreshIcon">
            <div>{{resource.refresh}}</div>
            <f7-link icon-f7="refresh" class="refreshIcon" @click="Retry('basicDetail')"></f7-link>
          </div>
          <div v-if="showNoTweetMsg">
            <div>{{resource.notweetFound}}</div>
          </div>
          <div v-if="TwitterUserDetail != null && TwitterMediaDetail===null && showRefreshIcon">
            <div>{{resource.refresh}}</div>
            <f7-link icon-f7="refresh" class="refreshIcon" @click="Retry('tweetDetail')"></f7-link>
          </div>
      </div>
      </f7-tabs>
      <infinite-loading @infinite="twitterinfiniteHandler" spinner="waveDots" class="twitter-infinite-loading" v-if="mediaList.length !== 0">
        <span slot="no-more">
          {{resource.noMoreTwitterDataAvailable}}
        </span>
        <span slot="no-results">
          {{resource.noMoreTwitterDataAvailable}}
        </span>
      </infinite-loading>
    </f7-page-content>
  </f7-page>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment'
  import InfiniteLoading from 'vue-infinite-loading'
  import * as Helper from '@/modules/helper/index'
  import {getRandomInt} from '@/modules/helper/index'
  import ImageFullScreen from '@/components/shared/ImageFullScreen.vue'
  export default {
    components: {
      appImageFullScreen: ImageFullScreen
    },
    data() {
      return {
        mediaList: [],
        loaded: false,
        currentVideo : [],
        videoElementObj:null,
        showRefreshIcon: false,
        dataLoaded: false,
        showDevSimInitMsg: false,
        showNoTweetMsg: false,
        imgLoaded: false
      }
    },
    computed: {
      ...mapGetters([
        'Twitter',
        'language',
        'MainMenuLayout',
        'resource',
        'TwitterUserDetail',
        'TwitterVideoArray',
        'TwitterMediaDetail',
        'InfiniteLoading',
      ]),
      randomNo() {
        return getRandomInt()
      },
      videoId() {
        return 'video-list-' + this.randomNo
      },
      subscriptionModuleId() {
        return this.$f7route.params.Id
      },
      lastId () {
        return this.mediaList && this.mediaList.length > 0 ? this.mediaList[this.mediaList.length-1].StatusID : 0
      }
    },
    watch: {
      Twitter: async function(value, oldvalue) {
        if(value.TwitterId != "" && value.TwitterId != oldvalue.TwitterId) {
          let PageContent = document.getElementsByClassName('twitterpage')[0]
          if (PageContent) {
            PageContent.scrollTop = 0
          }
          await this.getTwitterData()
        }
      }
    },
    created() {
      this.initTwitterModule(this.subscriptionModuleId)
    },
    beforeDestroy() {
      this.resetTwitterUserDetails({User: null})
      this.resetTwitterMediaDetails(null)
      this.mediaList = []
    },
    methods: {
      ...mapActions([
        'loadLocalTwitterData',
        'loadTwitterData',
        'getTwitterUserDetails',
        'getTwitterMediaDetails',
        'updateTwitterVideoArray',
        'resetTwitterMediaDetails',
        'resetTwitterUserDetails'
      ]),
      formattedDate: function(value) {
        return Helper.FormattedDateDDMMMMYY(value)
      },
      twitterDateFormat (value) {
        moment.locale(this.language)
        var check = moment(value)
        var currMonthName  = check.format('MMMM')
        var year = check.format('YYYY')
        var yearCurr = moment().format('YYYY')
        return (parseInt(year) === parseInt(yearCurr)) ? currMonthName : currMonthName + ' ' + year
      },
      nFormatter(num) {
        if (num >= 1000000000) {
          return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
        }
        if (num >= 1000000) {
          return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1000) {
          return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return num;
      },
      getVideoDivStyle (aspectObj) {
        return (aspectObj.Width < aspectObj.Height && aspectObj.Height - aspectObj.Width <= 6 ) ? 'padding-bottom : 100%;' : 'padding-bottom : 56.25%;'
      },
      getProfileFullImage (image) {
        if (image) {
          return image.replace("_normal","")
        }
      },
      getPhotoCaption(retweetCount, likeCount) {
        return '<div class="twitter-photo-caption">'+
                  '<div>'+
                    '<i class="retweet"></i> '+
                    '<span>' +retweetCount+ '</span>'+
                  '</div>' +
                  '<div>'+
                    '<i class="tweet-like"></i>'+
                    '<span>'+likeCount+'</span>'+
                  '</div>'+
                '</div>'
      },
      getPhotoArray (photoArray,retweetCount,likeCount) {
        var result = null
        var dpCoverPhotoArray = []
        if (retweetCount == null ) {
          dpCoverPhotoArray.push(photoArray)
          result = dpCoverPhotoArray.map(x => {
            x = this.getProfileFullImage(x)
            return {
              'url': x,
              'caption':'',
              'title': 'profilepiczoom'
            }
          })
        } else {
          result = photoArray.map(x => {
            retweetCount = retweetCount === 0 ? '' : this.nFormatter(retweetCount)
            likeCount = likeCount === 0 ? '' : likeCount = this.nFormatter(likeCount)
            return {
              'url': x.MediaUrlHttps,
              'caption': this.getPhotoCaption(retweetCount, likeCount)
            }
          })
        }
        return result
      },
      onClickImage(imageCount, photoImage) {
        let idString = photoImage.toString()
        const allPhotoArray = Object.keys(this.$refs).map(key => ({ key, value: this.$refs[key] }))
        let currentPhotoArray = allPhotoArray.filter(a => a.key === idString)
        if (photoImage == this.TwitterUserDetail.UserID || photoImage == this.TwitterUserDetail.StatusesCount) {
          currentPhotoArray[0].value.$children[0].open()
        } else {
          currentPhotoArray[0].value[0].$children[0].open(imageCount)
        }
      },
      async initTwitterModule(subscriptionModuleId) {
        this.$showLoader()
        await this.loadLocalTwitterData(subscriptionModuleId)
        try {
          await this.loadTwitterData(subscriptionModuleId)
          await this.getTwitterData()
          this.dataLoaded = true
          if (this.$refs.twitterContainer) {
            this.$refs.twitterContainer.$el.addEventListener('scroll', this.handleAutoplayPause)
          }
        } catch(err) {
          console.log('err', err)
          this.$hideLoader()
        }
        this.$hideLoader()
      },
      updateKeys (Obj) {
        Obj.accessTokenKey= this.Twitter.AccessToken
        Obj.accessTokenSecretKey= this.Twitter.AccessTokenSecretKey
        Obj.consumerSecretKey= this.Twitter.ConsumerSecretKey
        Obj.consumerKey= this.Twitter.ConsumerKey
      },
      getTwitterPaylod () {
        return {
          pageTitle: this.Twitter.TwitterId,
          id: this.Twitter.SubscriptionModule_Id,
          accessTokenKey: '',
          accessTokenSecretKey: '',
          consumerSecretKey: '',
          consumerKey: '',
          callFor: '',
          twitterPagination : null
        }
      },
      getBasicObject () {
        let basicObj = this.getTwitterPaylod()
        basicObj.callFor= 'id'
        if (Helper.IsDevSim()) {
          this.updateKeys(basicObj)
        }
        return basicObj
      },
      async getBasicDetail() {
        this.mediaList = []
        if(this.Twitter.TwitterId) {
          let obj = this.getBasicObject()
          let basicResult = await this.getTwitterUserDetails(obj)
          if (basicResult.ErrorCode !== null) {
            if (basicResult.User) {
              this.showRefreshIcon = true
              this.showDevSimInitMsg = false
            }
            else {
              this.showDevSimInitMsg = true
              this.showRefreshIcon = false
            }
          }
          return basicResult
        }
      },
      getAdvanceObject () {
        let advanceObj = this.getTwitterPaylod()
        advanceObj.pageTitle =  this.TwitterUserDetail.ScreenNameResponse
        advanceObj.twitterPagination= {
          maxPagination: '1',
          lastId: this.lastId
        }
        if (Helper.IsDevSim()) {
          this.updateKeys(advanceObj)
        }
        return advanceObj
      },
      async getAdvancedDetail () {
        let obj = this.getAdvanceObject()
        if(obj.pageTitle) {
          let advanceresult = await this.getTwitterMediaDetails(obj)
          if (advanceresult.ErrorCode ===null) {
            if (advanceresult.statuses.length === 0) {
              this.showNoTweetMsg = true;
              this.showDevSimInitMsg = false;
            } else {
              this.checkAndReplaceFullText()
              this.mediaList = this.TwitterMediaDetail
              this.showNoTweetMsg = false
            }
          } else {
              this.showRefreshIcon = true
          }
        } else {
            this.showRefreshIcon = true
        }
        this.$hideLoader()
      },
      async getTwitterData() {
        this.imgLoaded = false
        if (this.Twitter.TwitterId) {
          this.$showLoader()
          let res = await this.getBasicDetail()
          if (res.ErrorCode === null && this.TwitterUserDetail) {
            this.TwitterUserDetail.Description = Helper.checkAndMakeLink(this.TwitterUserDetail.Description)
            await this.getAdvancedDetail()
          } else {
            this.$hideLoader()
          }
          this.showDevSimInitMsg = false
        } else {
          this.showDevSimInitMsg = true
        }
      },
      async twitterinfiniteHandler($state) {
        let obj = this.getAdvanceObject() 
        if (this.TwitterUserDetail.StatusesCount > this.mediaList.length) {
          var tweetResponse = await this.getTwitterMediaDetails(obj)
          if (this.mediaList.length > 0) {
            this.checkAndReplaceFullText()
            this.mediaList.push.apply(this.mediaList, this.TwitterMediaDetail)
          } else{
            this.checkAndReplaceFullText()
            this.mediaList = this.TwitterMediaDetail
          }
          $state && $state.loaded()    
        } else if (this.TwitterUserDetail.StatusesCount === this.mediaList.length) {
          $state && $state.complete()
        }
      },
      async Retry (type) {
        this.showRefreshIcon = false
        if (type ==='basicDetail') {
          await this.getTwitterData()
        } else {
          await this.getAdvancedDetail()
        }
      },
      checkAndReplaceFullText () {
        this.TwitterMediaDetail && this.TwitterMediaDetail.forEach(tweet => {
          let urlLastPosition = tweet.FullText.lastIndexOf("https")
          if (urlLastPosition !== -1) {
            tweet.FullText = this.checkIsURL(tweet)
          }
        })
      },
      checkIsURL(tweet) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return tweet.FullText.replace(urlRegex, function(url) {
          let urlDetail = tweet.Entities.urls.find(urlInfo => urlInfo.url === url)
            return urlDetail ? '<a href="' + url + '">' + urlDetail.display_url + '</a>' : ''
        })
      },
      getVideoThumbnail (imageUrl) {
        return { 'background-image': 'url(' + imageUrl + ')' }
      },
      getVideoUrl (videoArray) {
        let videoUrl = ''
        var vidUrlArray = videoArray.filter(v=>v.BitRate === 832000)
        if (vidUrlArray.length === 0) {
          vidUrlArray = videoArray.filter(v=>v.BitRate === 256000)
        }
        if (videoArray.length === 1) {
          videoUrl = videoArray[0].Url
        } else if (vidUrlArray.length !==0) {
          videoUrl = vidUrlArray[0].Url
        }
        return videoUrl
      },
      checkPlayer (videoArray) {
        var vidUrlArray = []
        if (videoArray.length === 1) {
          vidUrlArray = videoArray
        } else {
          vidUrlArray = videoArray.filter(v=>v.BitRate === 832000)
          if (vidUrlArray.length === 0) {
            vidUrlArray = videoArray.filter(v=>v.BitRate === 256000)
          }
        }
        var curVedio = vidUrlArray[0]
        if( this.currentVideo.indexOf(vidUrlArray[0]) === -1) {
          this.currentVideo.push(vidUrlArray[0])
          this.updateTwitterVideoArray(this.currentVideo)
        }
        if (this.TwitterVideoArray.length > 0 && this.$refs.twitterVid) {
          let result = this.$refs.twitterVid.filter(o1 => this.TwitterVideoArray.find(o2 => o1.currentSrc === o2.Url))
          for (var i=0; i< result.length ;i++) {
            if(result[i].currentSrc !=  curVedio.Url) {
              result[i].pause()
            } else {
              this.videoElementObj = result[i]
            }
          }
        }
      },
      SetControl(){
        this.videoElementObj.controls = true 
      },
      handleAutoplayPause() {
        try {
          if (this.$refs.twitterVid)
          this.handleVideoViewPort()
        } catch (err) {
          console.log('error', err)
        }
      },
      handleVideoViewPort () {
        var isAutoplay = false
        this.$refs.twitterVid.forEach(videoElement => {
            if(Helper.isInViewPort(videoElement) && isAutoplay === false) {
              videoElement.play().catch(function(e) {
                //console.log('There was an error in play', e);
              })
              isAutoplay = true
            } else {
              videoElement.pause()
            }
          })
      },
      onLoaded() {
        this.imgLoaded = true
        // this.$hideLoader()
      }
    }
  }
</script>
<style scoped>
.refreshIcon >>> i.icon.f7-icons {
  font-weight: 600;
}
.twitter-icon-div {
  padding-left: 0px;
  align-items: center;
  display: flex;
  margin-top: -10px;
}
.twitter-tweet-card {
  padding-bottom: 0px;
}
.gif-label{
  color: white;
  background-color: black;
  font-weight: bold;
  padding: 1px 5px 1px 6px;
  position: absolute;
  bottom: 8px;
  z-index: 9;
  left: 8px;
  font-size: 12px;
}
.twitter-video-div {
  position: relative;
  background-size: cover;
  border-radius: 14px;
  border: 1px solid gainsboro;
  overflow: hidden;
  margin-bottom: 5px;
  width:100%;
  margin-top: 6px;
}
.twitter-video-outer-div {
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 9;
  width: 100%;
  text-align: center;
  overflow: hidden;
  border-radius: 14px;
}
.tweet-icon-padding {
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: -12px;
  margin-top: 0;
  padding-top: 0;
  color: inherit !important;
}
.calender-font-icon {
  margin-right: 8px !important;
  font-size: 12px !important
}
.twitter-user-name{
  font-size:20px;
}
.twitter-post-date{
  float: right;
}
.twitter-post-username{
  padding-right: 1px;
  font-size: 15px;
}
.twitter-post-description{
  white-space: pre-line;
  line-height: 20px;
  word-break: break-word;
  margin-top: 3px;
  margin-bottom: 0px; 
}
.twitter-description {
  font-size:15px;
  margin-bottom:8px;
  margin-top: 5px;
}
.twitter-cover {
  max-width: 100%;
  max-height: 500px;
  background-color: rgb(204, 214, 221);
  position: relative;
}
.twitter-cover .banner_height {
  padding-bottom: 33.3%;
}
.twitter-cover .no_banner_height {
  min-height: 125px;
}
.twitter-cover .inner-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.twitter-cover img {
 max-width: 100%;
  position: absolute;
  left: 0px;
  right: 0px;
  top: -9999px;
  bottom: -9999px;
  width: 100%;
  margin: auto 0px;
}
.twitter-card-header {
  padding:0;
  border: none !important;
  display: block !important;
}
.twitter-user-info {
  padding: 45px 16px 3px;
  box-sizing: border-box;
  font-size:14px;
  position:relative;
}
.twitter-user-info .profile-pic{
  position:absolute;
  top: -26%;
  z-index: 999; 
}
.twitter-user-other-info{
  margin-bottom:5px;
  font-size: 14px;
}
.twitter-user-other-info span{
  display:flex;
  align-items:center;
  font-size: 14px;
}
.twitter-user-other-info i{
  font-size: 15px;
  margin-left: -2px;
  margin-right: 5px !important;
  padding-bottom: 1px;
  margin-top: 1px;
  color: inherit !important;
  width:15px;
}
.twitter-span-margin {
  margin-left: 10px;
}
.twitter-case {
 text-transform: capitalize !important;
}
.twitter-tab-bar {
  background-color:#fff !important;
}
.twitter-tab-bar:before {
  display:none;
}
.layout-onAirDefault  .twitter-tab-bar.tabbar a:not(.active) {
  color: #999;
}
.twitter-tab-bar .toolbar-inner a.tab-link {
  border-bottom: 2px solid #f6f6f6;
}
.twitter-tab-bar .toolbar-inner a.tab-link-active {
  border: none;
  font-weight: bold;
  color: #007aff !important;
  border-bottom: 2px solid #007aff;
}
.twitter-tabs .page-content {
  padding: 0 !important;
  overflow-x: hidden !important;
}
.twitter-tabs .card {
  background-color:transparent;
  box-shadow:none;
  border-bottom: 1px solid;
  cursor: pointer;
  margin-right: 0px;
  margin-left: 0px;
  margin-top:0px;
  margin-bottom: 3px;
}
.md .twitter-tabs .page-content > .card:last-child {
  margin-bottom: 3px !important; 
}
.twitter-icon {
  font-size: 12px;
  margin-right: 7px;
}
.show-media-image img {
  width: 100%;
  height: 100%;
}
.show-profile-pic-small {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  min-width: 45px;
  min-height: 45px;
}
.twitter-profilepic {
  border-radius: 50%;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.profile-pic{
  width: 80px;
  height: 80px;
  border: 2px solid #fff;
  border-radius: 50%;
  left: 14px;
}
.profile-pic img{
  width: 100%;
  height: 100%;
}
.twitter_screenName {
  font-size: 15px;
  font-weight: 400;
}
.show-media-image {
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  overflow: hidden;
  height: 202px;
  margin-top: 10px;
  margin-bottom: 5px;
  border: 1px solid gainsboro;
}
.show-media-image div {
  width: 50%;
  background-size: cover;
  background-position: center;
  flex-grow: 1;
}
.gallery4 div:nth-child(1) {
  margin-right: 2px;
  margin-bottom: 2px;
}
.gallery4 div:nth-child(2) {
  margin-bottom: 2px;
}
.gallery4 div:nth-child(3) {
  margin-right: 2px;
}
.gallery4 div {
  width: 49%;
}
.gallery3 {
  flex-direction: column;
}
.gallery3 div:nth-child(1) {
  height: 200px;
  flex-grow: 1;
  margin-right: 2px;
}
.gallery3 div:nth-child(2) {
  margin-bottom: 2px;
  height: 100px;
}
.gallery3 div:nth-child(3) {
  height: 100px;
}
.gallery2 div{
  width: 49%;
}
.gallery2 div:nth-child(1) {
  flex-grow: 1;
  margin-right: 2px;
}
.retweet-rotate {
  transform: rotate(90deg);
  color: #657786;
  display: inline-block;
  width: 15px !important;
  height: 15px !important;
  background-size: 100%;
  float: right;
  margin-top: 1px;
  margin-bottom: 5px;
  margin-right: -1px;
  transform: rotate(180deg);
}
.card-footer:before{
  display:none;
}
.md .card-header, .md .card-footer {
  min-height: 40px !important;
 }
.outer-container {
  text-align: center;
  margin-top: 10px;
}
.no-page-found {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.twitterpage {
  padding-top: 34px!important;
}
.tweet-profile-pic{
  width: 45px;
  max-width: 45px;
  max-height: 45px;
  min-width: 45px;
  margin-right: 12px;
}
.tweet-details{
  display:flex;
}
.justify-content-between{
  justify-content:space-between;
}
.flex-grow-1{
  flex-grow:1;
}
@media screen and (min-width:768px){
  .twitter-user-info .profile-pic{
    top: -50%;
  }
  .profile-pic {
    width: 200px;
    height: 200px;
  }
  .twitter-user-info {
    padding: 95px 16px 3px;
  }
  .twitter-cover .banner_height {
    padding-bottom: 29.3%;
  }
  .twitter-cover .no_banner_height {
    min-height: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/twitter/TwitterPage.vue